import Reveal from '@/pages/zz-review/components/Reveal';

const categories = [
  '個體生命實踐',
  '跨文化與跨宗教生命成長',
  '科技與生命',
  '企業與治理',
  '生命共同體',
  '文明永續',
];

export default function BookshelfSection() {
  return (
    <section id="bookshelf" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              1001 宇宙書架
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              一套持續生長的生命與文明書架
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
              1001 宇宙書信是訊息與思想源流，經整理、系統化後，成為 1001 宇宙書架——一套系統化出版體系；《1001旋轉門》是書架的首階生命實踐著作，也是目前主要的 5D 入口。未來將由不同書籍分別展開：
            </p>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
            {categories.map((category) => (
              <div
                key={category}
                className="rounded-lg border border-background-200/70 bg-background-100 px-5 py-5 flex items-center gap-3"
              >
                <span className="w-2 h-2 rounded-full bg-primary-400 shrink-0" />
                <span className="text-sm md:text-base text-foreground-800">{category}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={100}>
          <p className="text-center text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto">
            書籍與 Portal 將彼此連接，形成可以閱讀，也可以實踐的長程知識與生命系統。
          </p>
        </Reveal>
      </div>
    </section>
  );
}